export default __webpack_public_path__ + "static/media/Border Kingdom Headdress.97080816.jpg";